/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Digital_ArtInputs */

const en_val_digital_art = /** @type {(inputs: Val_Digital_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital Art`)
};

const es_val_digital_art = /** @type {(inputs: Val_Digital_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arte digital`)
};

const fr_val_digital_art = /** @type {(inputs: Val_Digital_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art numérique`)
};

const de_val_digital_art = /** @type {(inputs: Val_Digital_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digitale Kunst`)
};

const ja_val_digital_art = /** @type {(inputs: Val_Digital_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デジタルアート`)
};

const zh_val_digital_art = /** @type {(inputs: Val_Digital_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字艺术`)
};

const ar_val_digital_art = /** @type {(inputs: Val_Digital_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فن رقمي`)
};

const id_val_digital_art = /** @type {(inputs: Val_Digital_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seni Digital`)
};

const it_val_digital_art = /** @type {(inputs: Val_Digital_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arte Digitale`)
};

const ru_val_digital_art = /** @type {(inputs: Val_Digital_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цифровое искусство`)
};

const pt_val_digital_art = /** @type {(inputs: Val_Digital_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arte Digital`)
};

const ko_val_digital_art = /** @type {(inputs: Val_Digital_ArtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디지털 아트`)
};

/**
* | output |
* | --- |
* | "Digital Art" |
*
* @param {Val_Digital_ArtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_digital_art = /** @type {((inputs?: Val_Digital_ArtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Digital_ArtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_digital_art(inputs)
	if (locale === "es") return es_val_digital_art(inputs)
	if (locale === "fr") return fr_val_digital_art(inputs)
	if (locale === "de") return de_val_digital_art(inputs)
	if (locale === "ja") return ja_val_digital_art(inputs)
	if (locale === "zh") return zh_val_digital_art(inputs)
	if (locale === "ar") return ar_val_digital_art(inputs)
	if (locale === "id") return id_val_digital_art(inputs)
	if (locale === "it") return it_val_digital_art(inputs)
	if (locale === "ru") return ru_val_digital_art(inputs)
	if (locale === "pt") return pt_val_digital_art(inputs)
	return ko_val_digital_art(inputs)
});